export const canEditDimensionesPublicacion = (publicacion, dimensionesPrevias) => {
    const verifyDimensiones = ["alto", "ancho", "peso", "profundidad"];
    let canEditDimensiones = false;
    if (publicacion.dimensiones.length === dimensionesPrevias.length) {
        for (let i = 0; i < publicacion.dimensiones.length; i++) {
            canEditDimensiones = verifyDimensiones.some(item => publicacion.dimensiones[i][item] !== dimensionesPrevias[i][item]);
            if (canEditDimensiones) break;
        }
    } else {
        canEditDimensiones = true;
    }

    return canEditDimensiones;
}